var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
export var RollbackIcon = function (props) { return (_jsx("svg", __assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: _jsx("path", { d: "M5.828 6.99999L8.364 9.53599L6.95 10.95L2 5.99999L6.95 1.04999L8.364 2.46399L5.828 4.99999H13C15.1217 4.99999 17.1566 5.84284 18.6569 7.34313C20.1571 8.84342 21 10.8783 21 13C21 15.1217 20.1571 17.1566 18.6569 18.6568C17.1566 20.1571 15.1217 21 13 21H4V19H13C14.5913 19 16.1174 18.3678 17.2426 17.2426C18.3679 16.1174 19 14.5913 19 13C19 11.4087 18.3679 9.88257 17.2426 8.75735C16.1174 7.63213 14.5913 6.99999 13 6.99999H5.828Z", fill: "currentColor" }) }))); };
